module.exports = __webpack_public_path__ + "static/media/adhaar.3d37c61d.jpg";